import { render, staticRenderFns } from "./EditSponsor.vue?vue&type=template&id=0d82cf16&"
import script from "./EditSponsor.vue?vue&type=script&lang=js&"
export * from "./EditSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports